import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { DYNAMIC_TARIFF_ZONES_LEGEND } from '../../../constants/legends';

const DynamicTariffZonesLegendComponent = () => (
    <div>
        <LegendRenderer config={DYNAMIC_TARIFF_ZONES_LEGEND} />
    </div>
);

export const DynamicTariffZonesLegend = withDisplayedLayersCheck(DynamicTariffZonesLegendComponent, t`Особые зоны динамического тарифа`);
